import {
  ArrowLeft,
  Block,
  ButtonIcon,
  HeadingXSmall,
  ModalHeader,
  useStyletron,
} from "@mezo-org/mezo-clay"

import SlideMenu, {
  SlideMenuDirection,
  SlideMenuProps,
} from "#/shared/components/SlideMenu"

type SwapModalFormSettingsWrapperProps = Omit<SlideMenuProps, "header"> & {
  title: string
}

export default function SwapModalFormSettingsWrapper({
  isOpen,
  onClose,
  children,
  title,
}: SwapModalFormSettingsWrapperProps) {
  const [css, theme] = useStyletron()

  return (
    <SlideMenu
      isOpen={isOpen}
      onClose={onClose}
      closable={false}
      direction={SlideMenuDirection.RIGHT}
      header={
        <ModalHeader
          $style={{
            display: "grid",
            gridTemplateColumns: `${theme.sizing.scale1000} 1fr ${theme.sizing.scale1000}`,
            alignItems: "center",
            margin: 0,
          }}
        >
          <ButtonIcon size="small" onClick={onClose} type="button">
            <ArrowLeft size={theme.sizing.scale600} />
          </ButtonIcon>
          <Block
            className={css({
              display: "flex",
              width: "100%",
              justifyContent: "center",
            })}
          >
            <HeadingXSmall>{title}</HeadingXSmall>
          </Block>
        </ModalHeader>
      }
    >
      <Block
        className={css({
          display: "flex",
          flexDirection: "column",
          height: "490px",
          padding: `0 ${theme.sizing.scale800} ${theme.sizing.scale800}`,
        })}
      >
        {children}
      </Block>
    </SlideMenu>
  )
}
